import { Dropdown as BootstrapDropdown } from 'react-bootstrap'
import { useState } from 'react'
import { startCase } from 'lodash'
import './Dropdown.scss'

const Dropdown = ({
  items,
  selected,
  onSelect,
  label = 'Select an option',
  name,
  disabled = false,
  required = false,
}: Props) => {
  const [open, setOpen] = useState(false)
  const dropdownId = `dropdown-${Math.random().toString(36).substr(2, 9)}`
  const showError = required && !selected

  const handleSelect = (item: DropdownItem) => {
    const syntheticEvent = {
      target: {
        name,
        value: item.value,
        type: 'select-one',
      },
    }
    onSelect(syntheticEvent)
    setOpen(false)
  }

  const alphabeticallySortedItems = items.sort((a, b) =>
    a.label.localeCompare(b.label)
  )

  return (
    <div className="position-relative">
      {label && (
        <label htmlFor={dropdownId} className="form-label">
          {label}
        </label>
      )}
      <BootstrapDropdown
        show={open}
        onToggle={() => setOpen(!open)}
        className="w-100"
      >
        <BootstrapDropdown.Toggle
          id={dropdownId}
          aria-haspopup="listbox"
          aria-expanded={open}
          aria-controls={`${dropdownId}-list`}
          className={`w-100 text-start ${showError ? 'is-invalid' : ''}`}
          variant="outline-secondary"
          disabled={disabled}
        >
          {selected?.label || 'Select'}
        </BootstrapDropdown.Toggle>

        <BootstrapDropdown.Menu
          role="listbox"
          id={`${dropdownId}-list`}
          className="w-100"
        >
          {alphabeticallySortedItems.map((item) => (
            <BootstrapDropdown.Item
              as="button"
              key={item.value}
              role="option"
              aria-selected={selected?.value === item.value}
              onClick={(e) => {
                e.preventDefault()
                handleSelect(item)
              }}
            >
              {item.label}
            </BootstrapDropdown.Item>
          ))}
        </BootstrapDropdown.Menu>
      </BootstrapDropdown>

      {showError && (
        <div className="text-danger py-3 px-3">{startCase(name)} Required</div>
      )}
    </div>
  )
}

export default Dropdown